import { useAppSelector } from '../../redux/useAppSelector';
import { isCustomFieldValueEmpty } from '../isCustomFieldValueEmpty';
import { useCustomFieldsVisibility } from '../useCustomFieldsVisibility';
import { CustomField } from '../useLazyCustomFields';

/** Return the custom fields that have empty values. */
export function useRequiredAndVisibleCustomFields(
  customFields: readonly CustomField[],
): readonly CustomField[] {
  const queue = useAppSelector(
    (state) => state.conversation?.metaConversation?.conversation?.queue,
  );

  const visibility = useCustomFieldsVisibility(customFields, {
    queue: [queue?.id ?? ''],
  });

  return customFields.filter(({ attribute: { id, is_required }, value }) => {
    if (!visibility.data[id]) {
      return false;
    }

    return is_required && isCustomFieldValueEmpty(value);
  });
}
